'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'dumpster-fire';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f794';
var svgPathData = 'M67.4 64l506.2 0 2.6 12.9 27.2 135.9c-8.6-8.7-18-17.3-28.2-25.8l-11.6-9.6-16.3-81.3-72.6 0 9.7 64-29.1-29.1-7 4.4-6-39.3-105.9 0 0 128 3 0c-2.9 3.4-5.8 6.8-8.6 10.3-5.4 6.8-10.8 14-15.9 21.7l-216.4 0 20 160 156.3 0c1.7 11 4.3 21.7 7.6 32l-160 0 4 32-32.2 0-28-224-37.4 0 3.8-19.1 32-160 2.6-12.9zM304.5 96l-106.2 0-19.2 128 125.4 0 0-128zM165.9 96l-72.3 0-25.6 128 78.7 0 19.2-128zm282.6 96c30.7 30.7 52 52 64 64 17.3-17.3 28-28 32-32 76.8 64 96 133.3 96 160 0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm86.6 86.6l-22.6 22.6c-11.4-11.4-33.9-33.9-67.6-67.6-16.2 12.7-34.9 30-51.4 50.7-24.3 30.5-41 65-41 99.7 0 33.3 12.7 63.6 33.5 86.3-1-5.1-1.5-10.4-1.5-15.8 0-70.4 96-134.4 96-134.4s96 64 96 134.4c0 5.4-.5 10.6-1.5 15.8 20.8-22.8 33.5-53.1 33.5-86.3 0-14.1-11-63.7-63-115.8l-10.4 10.4zM480.5 512.1c37.5 0 64-27.8 64-57.6 0-21.9-15.9-47.5-39-71.3-8.8-9-17.6-16.9-25-23-7.4 6.1-16.2 13.9-25 23-23.1 23.8-39 49.5-39 71.3 0 29.8 26.5 57.6 64 57.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpsterFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;